var render = function render(_c,_vm){return _c('span',[_vm._v("no prototype")])
}
var staticRenderFns = []

export { render, staticRenderFns }